export var seoThemeType = {
  make: 'make',
  location: 'location',
  makeLocation: 'make_location'
};